import { Controller } from "@hotwired/stimulus";
import walletService from "../../../services/WalletService";
import { storage } from "../../../storageconstants";
import { debugLog } from "../../../utils";

export default class extends Controller {
  async connect() {
    sessionStorage.setItem(storage.THIRD_PARTY_BACK_TARGET, "connect-wallet-only");

    // Browser back restores a cached page with stale Onboard state.
    // Force a one-time hard reload to get a clean runtime.
    if (this.shouldForceReload()) {
      sessionStorage.setItem(storage.TURBO_RESTORE_RELOADED, "1");
      sessionStorage.removeItem(storage.TURBO_RESTORE_PENDING);
      window.location.reload();
      return;
    }
    sessionStorage.removeItem(storage.TURBO_RESTORE_RELOADED);

    await this.resetThirdPartyWalletConnection();
    this.hideLoadingScreen();
  }

  shouldForceReload() {
    const isRestore = sessionStorage.getItem(storage.TURBO_RESTORE_PENDING) === "1";
    const alreadyReloaded = sessionStorage.getItem(storage.TURBO_RESTORE_RELOADED) === "1";
    return isRestore && !alreadyReloaded;
  }

  async continue(event) {
    event?.preventDefault();

    try {
      this.dispatch("listenWalletChange");
      await walletService.prepareForNewConnection();
      await walletService.connectWallet();

      const connectedWallet = await walletService.getWalletAddress();
      if (connectedWallet) {
        this.showLoadingScreen();
        return;
      }
      debugLog("ConnectWalletOnly: wallet connection did not return an address");
    } catch (error) {
      debugLog("ConnectWalletOnly: connect wallet failed", error);
      this.dispatch("error", {
        detail: { content: "Unable to open wallet connection. Please refresh and try again." },
      });
    }
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }

  async resetThirdPartyWalletConnection() {
    try {
      await walletService.disconnectWallet();
    } catch (error) {
      debugLog("ConnectWalletOnly: failed to disconnect wallet on load", error);
    }
  }
}
